import { Box, Card, Switch, TextField, Typography,  } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MapIcon from '@material-ui/icons/Map';
import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';
import { BooleanInput, TextInput, ImageInput, ImageField, required, } from 'react-admin';
import DateTimePicker from 'react-datetime-picker';
import Geocode from 'react-geocode';
import { useDispatch } from 'react-redux';
import { checkDateError } from '../../helpers/checkDreamHome';
import {
  changeAddress,
  changeLatitude,
  changeLongitude,
  setEmailGalleryFile
} from '../../redux/actions/propertyActions';
import { Raffle } from '../../types/raffle';
import { GeneralTabErrors } from '../../types/tabsError';
import ImagesField, { ImagesTypeEnum } from '../common/imagesField/ImagesField';
import Map from '../common/map/Map';
import './index.css';

let baseGeoCodeURL = 'https://maps.googleapis.com/maps/api/geocode/json?key=';
interface State {
  showDialog: boolean;
  latitude: number | undefined;
  longitude: number | undefined;
  address: string;
  endDate: Date | string;
  startDate: Date | string;
  startDateError: boolean;
  endDateError: boolean;
  title: string;
  bundleTitle: string;
  isActiveDreamHome: boolean;
  stepperTitle: string;
  stepperStartAt: Date | string;
  stepperEndsAt: Date | string;
  stepperIsActive: boolean;
  stepperStartDateError: boolean;
  stepperEndDateError: boolean;
}

const titleOptions = [
  { id: 'london', title: 'London' },
  { id: 'copperworks', title: 'Copperworks' },
];
interface Props {
  record: Raffle | undefined;
  isShow: boolean;
  setAddress: (address: string) => void;
  adress: string;
  latitude: number;
  longitude: number;
  imagesError: boolean;
  emailGalleryImageError: boolean;
  fillGeneralForm: (name: string, value: string) => void;
  generalError: GeneralTabErrors;
  fillGeneralFormEdit?: (
    titleFill: string,
    startDateFill: string,
    endDateFill: string,
    stepperIsActive: boolean,
    stepperStartDateFill: string,
    stepperEndDateFill: string,
    stepperTitle: string,
    title: string,
    bundleTitle: string
  ) => void;
}

const DreamHomeGeneral: FC<Props> = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState<State>({
    showDialog: false,
    latitude: parseFloat(
      (props.record &&
        Object.keys(props.record).length > 0 &&
        props.record.property.latitude + '') ||
        ''
    ),
    longitude: parseFloat(
      (props.record &&
        Object.keys(props.record).length > 0 &&
        props.record.property.longitude + '') ||
        ''
    ),
    title: '',
    bundleTitle: '',
    address: '',
    endDate: '',
    startDate: '',
    startDateError: false,
    endDateError: false,
    stepperIsActive: false,
    stepperTitle: 'Stepper Title',
    stepperStartAt: '',
    stepperEndsAt: '',
    stepperStartDateError: false,
    stepperEndDateError: false,
    isActiveDreamHome: false,
  });
  const [hasEmailGalleryImage, emailGalleryImage] = useState<boolean>(!!props.record?.property.emailGalleryImage);
  useEffect(() => {
    dispatch(changeAddress(''));
    if (props.record && props.record.property) {
      if (typeof props.record.property === 'object') {
        if (props.fillGeneralFormEdit) {
          const stepperCountdown = props.record.stepperCountdown;
          props.fillGeneralFormEdit(
            props.record?.name || '',
            props.record.startAt ? props.record.startAt : '',
            props.record.endsAt,
            stepperCountdown ? stepperCountdown.isActive : false,
            stepperCountdown ? stepperCountdown.startAt : '',
            stepperCountdown ? stepperCountdown.endsAt : '',
            stepperCountdown ? stepperCountdown.title : '',
            props.record.title || titleOptions[0].id,
            props.record.bundleTitle ? props.record.bundleTitle : ''
          );
        }
        dispatch(changeAddress(props.record.property.location));
        dispatch(changeLatitude(props.record.property.latitude));
        dispatch(changeLongitude(props.record.property.longitude));
        dispatch(setEmailGalleryFile(props.record.property.emailGalleryImage));
        const startDateError = checkDateError({
          endsAt: props.record.endsAt,
          startAt: props.record.startAt,
        });
        const stepperCountdown = props.record.stepperCountdown;
        setState({
          ...state,
          startDateError: startDateError,
          latitude: props.latitude,
          longitude: props.longitude,
          endDate: new Date(props.record.endsAt || new Date()),
          startDate: new Date(props.record.startAt || new Date()),
          stepperTitle: stepperCountdown ? stepperCountdown.title : '',
          stepperIsActive: stepperCountdown ? stepperCountdown.isActive : false,
          stepperStartAt: new Date(
            stepperCountdown ? stepperCountdown.startAt : new Date()
          ),
          stepperEndsAt: new Date(
            stepperCountdown ? stepperCountdown.endsAt : new Date()
          ),
          isActiveDreamHome: props.record.active,
          bundleTitle: props.record.bundleTitle ? props.record.bundleTitle : '',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const appKey = process.env.REACT_APP_GOOGLE_API_KEY || '';
    let lat = 0;
    let lon = 0;
    const address = e.target.value;
    props.setAddress(address);
    dispatch(changeAddress(address));
    const response = await axios.get(
      baseGeoCodeURL + appKey + '&address=' + e.target.value
    );
    if (response && response.data) {
      if (response.data.results && response.data.results.length) {
        lat = response.data.results[0].geometry.location.lat;
        lon = response.data.results[0].geometry.location.lng;
      }
    }
    dispatch(changeLatitude(lat));
    dispatch(changeLongitude(lon));
    setState({ ...state, latitude: lat, longitude: lon, address: address });
  };

  const handleChangeLatitude = async (e) => {
    let address = '';
    Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API_KEY || '');
    const longitude = state.longitude || props.longitude;
    const latitude = e.target.value;
    setState({ ...state, latitude: parseFloat(latitude) });
    if (latitude) {
      try {
        const result = await Geocode.fromLatLng(latitude, longitude.toString());
        address = result.results[0].formatted_address;
        props.setAddress(address);
        dispatch(changeAddress(address));
      } catch (error) {
        props.setAddress(address);
        dispatch(changeLatitude(parseFloat(latitude)));
      }
    }
    dispatch(changeLatitude(parseFloat(latitude)));
    setState({ ...state, latitude: parseFloat(latitude), address: address });
  };

  const handleChangeLongitude = async (e) => {
    let address = '';
    Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API_KEY || '');
    const latitude = state.latitude || props.latitude;
    const longitude = e.target.value;
    setState({ ...state, longitude: parseFloat(longitude) });
    if (latitude) {
      try {
        const result = await Geocode.fromLatLng(latitude.toString(), longitude);
        address = result.results[0].formatted_address;
        props.setAddress(address);
        dispatch(changeAddress(address));
      } catch (error) {
        props.setAddress(address);
        dispatch(changeLongitude(parseFloat(longitude)));
      }
    }
    dispatch(changeLatitude(parseFloat(longitude)));
    setState({ ...state, longitude: parseFloat(longitude), address: address });
  };

  const handleTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, title: event.currentTarget.value });
    props.fillGeneralForm('title', event.currentTarget.value);
  };
  const handleBundleTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, bundleTitle: event.currentTarget.value });
    props.fillGeneralForm('bundleTitle', event.currentTarget.value);
  };
  const handleChangeStepperTitle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setState({ ...state, stepperTitle: event.currentTarget.value });
    props.fillGeneralForm('stepperTitle', event.currentTarget.value);
  };

  const handleChangeStepperCountdownActive = (event) => {
    setState({ ...state, stepperIsActive: event.currentTarget.checked });
    props.fillGeneralForm('stepperIsActive', event.currentTarget.checked);
  };

  const setEndDate = (value: Date) => {
    if (value) {
      let error = false;
      const startDate = new Date(state.startDate).getTime();
      const endDate = value.getTime();
      if (startDate >= endDate) {
        error = true;
      }
      props.fillGeneralForm('endDateFill', value.toString());
      setState({
        ...state,
        endDate: value,
        endDateError: error,
        startDateError: false,
      });
    }
  };

  const setStepperEndDate = (value: Date) => {
    if (value) {
      let error = false;
      const startDate = new Date(state.stepperStartAt).getTime();
      const endDate = value.getTime();
      if (startDate >= endDate) {
        error = true;
      }
      props.fillGeneralForm('stepperEndDateFill', value.toString());
      setState({
        ...state,
        stepperEndsAt: value,
        stepperEndDateError: error,
        stepperStartDateError: false,
      });
    }
  };

  const setStepperStartDate = (value: Date) => {
    if (value) {
      let error = false;
      const endDate =
        typeof state.stepperEndsAt === 'string'
          ? new Date(state.stepperEndsAt).getTime()
          : state.stepperEndsAt.getTime();
      const startDate = value.getTime();
      if (startDate >= endDate) {
        error = true;
      }
      props.fillGeneralForm('stepperStartDateFill', value.toString());
      setState({
        ...state,
        stepperStartAt: value,
        stepperStartDateError: error,
        stepperEndDateError: false,
      });
    }
  };

  const setStartDate = (value: Date) => {
    if (value) {
      let error = false;
      const endDate =
        typeof state.endDate === 'string'
          ? new Date(state.endDate).getTime()
          : state.endDate.getTime();
      const startDate = value.getTime();
      if (startDate >= endDate) {
        error = true;
      }
      props.fillGeneralForm('startDateFill', value.toString());
      setState({
        ...state,
        startDate: value,
        startDateError: error,
        endDateError: false,
      });
    }
  };

  const openModal = () => {
    if (!props.isShow) {
      setState({ ...state, showDialog: true });
    }
  };

  const closeModal = () => {
    setState({ ...state, showDialog: false });
  };

  const onDragEnd = async (e) => {
    Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API_KEY || '');
    const result = await Geocode.fromLatLng(e.latLng.lat(), e.latLng.lng());
    const address = result.results[0].formatted_address;
    setState({
      ...state,
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng(),
      address: address,
    });
    props.setAddress(address);
    dispatch(changeAddress(address));
    dispatch(changeLatitude(e.latLng.lat()));
    dispatch(changeLongitude(e.latLng.lng()));
  };

  const changeEmailGalleryImage = (file?: File) => {
    dispatch(setEmailGalleryFile(file));
    emailGalleryImage(!!file);
  };

  return (
    <>
      <Box display={{ md: 'block', lg: 'flex' }} justifyContent='space-between'>
        <Box width={{ md: '100%', lg: '60%' }} marginTop='2em'>
          <Card>
            <Box padding='2em' className='general-title-input'>
              <ImagesField
                error={props.generalError.imagesError}
                title='Add images for desktop'
                awsFolder='properties'
                imagesKey={
                  props.record?.property
                    ? props.record?.property.galleryImages
                    : undefined
                }
              />
              <ImagesField
                error={props.generalError.imagesError}
                imagesType={ImagesTypeEnum.MOBILE}
                title='Add images for mobile'
                awsFolder='properties'
                imagesKey={
                  props.record?.property
                    ? props.record?.property.galleryImagesMobile
                    : undefined
                }
              />
              <ImageInput
                source='property.filesEmailGallery'
                label='Add an image for email gallery (gif)'
                multiple={false}
                className='base-color image-field add-email-gallery-image'
                onChange={changeEmailGalleryImage}
                disabled={props.isShow}
                isRequired={true}
              >
                <ImageField source='src' title='title' />
              </ImageInput>
              {!hasEmailGalleryImage && props.generalError.emailGalleryImageError && (
                <p className="common-error mt-0">Required</p>
              )}
              <Typography variant='h6' gutterBottom className='base-color'>
                Title
              </Typography>
              <TextInput
                className='input-form'
                onChange={handleTitle}
                disabled={props.isShow}
                source='title'
                label='Title'
                fullWidth
              />
              {!state.title && props.generalError.titleError && (
                <div className='validate-address-error'>Required</div>
              )}
              {state.title.length > 50 && (
                <div className='validate-address-error'>
                  Must be 50 characters or less
                </div>
              )}
              <Typography variant='h6' gutterBottom className='base-color'>
                Bundle Title
              </Typography>
              <TextInput
                className='input-form'
                onChange={handleBundleTitle}
                disabled={props.isShow}
                source='bundleTitle'
                label='Bundle Title'
                fullWidth
              />
              {/* <Box marginTop='2em'>
                <Typography variant='h6' className='base-color'>
                  Address
                </Typography>
              </Box>
              <Box
                display='flex'
                alignItems='flex-end'
                className='coordinate-wrapper'
              >
                <div className='coordinates'>
                  <TextField
                    label='Address*'
                    className='address-field'
                    disabled={props.isShow}
                    value={props.adress}
                    onChange={handleChange}
                  />
                </div>
                <MapIcon onClick={openModal} className='map-icon' />
                <Dialog
                  open={state.showDialog}
                  onClose={closeModal}
                  aria-label='Create post'
                  className='mapDialogWrapper'
                >
                  <div className='map-wrapper'>
                    <Map
                      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}`}
                      latitude={state.latitude || props.latitude}
                      longitude={state.longitude || props.longitude}
                      loadingElement={<div style={{ height: '100%' }} />}
                      containerElement={<div style={{ flex: 1 }} />}
                      mapElement={<div style={{ height: '100%' }} />}
                      onDragEnd={onDragEnd}
                    />
                    <Box
                      display='flex'
                      paddingY='1rem'
                      alignItems='center'
                      justifyContent='space-around'
                    >
                      <TextField
                        label='Address*'
                        className='address-field'
                        disabled={props.isShow}
                        value={props.adress}
                        onChange={handleChange}
                      />
                      <TextField
                        className='address-field'
                        type='number'
                        value={state.latitude || props.latitude}
                        label=''
                        onChange={handleChangeLatitude}
                      />
                      <TextField
                        className='address-field'
                        type='number'
                        value={state.longitude || props.longitude}
                        label=''
                        onChange={handleChangeLongitude}
                      />
                    </Box>
                  </div>
                </Dialog>
              </Box>
              {!state.address && props.generalError.adressError && (
                <div className='validate-address-error'>Required</div>
              )} */}
            </Box>
          </Card>
        </Box>
        <Box width={{ md: '100%', lg: '38%' }} marginTop='2em'>
          <Card>
            <Box padding='2em'>
              <Typography variant='h6' gutterBottom className='base-color'>
                CountDown & Status
              </Typography>
              <hr />
              <Box
                display='flex'
                alignItems='center'
                justifyContent='flex-start'
              >
                <Typography gutterBottom className='base-color'>
                  Status
                </Typography>
                <BooleanInput
                  label=''
                  source='active'
                  disabled={props.isShow}
                />
              </Box>
              <Box
                display='flex'
                alignItems='center'
                justifyContent='flex-start'
              >
                <Typography gutterBottom className='base-color'>
                  Start date
                </Typography>
                <Box>
                  <DateTimePicker
                    // disabled={state.isActiveDreamHome}
                    value={state.startDate}
                    format={'dd-MM-y h:mm:ss a'}
                    onChange={setStartDate}
                    maxDate={new Date('2051-01-18T19:55:00.000+00:00')}
                    minDate={new Date('2000-01-18T19:55:00.000+00:00')}
                    disableClock
                  />
                  <Box position='absolute'>
                    {state.startDateError && (
                      <div className='date-error'>
                        Start date cannot be later than finish date
                      </div>
                    )}
                  </Box>
                  {!state.startDate && props.generalError.startDateError && (
                    <div className='validate-address-error'>Required</div>
                  )}
                </Box>
              </Box>
              <Box
                display='flex'
                alignItems='center'
                justifyContent='flex-start'
                marginTop='2em'
              >
                <Typography gutterBottom className='base-color'>
                  Finish date
                </Typography>
                <Box>
                  <DateTimePicker
                    value={state.endDate}
                    format={'dd-MM-y h:mm:ss a'}
                    onChange={setEndDate}
                    maxDate={new Date('2051-01-18T19:55:00.000+00:00')}
                    minDate={new Date('2000-01-18T19:55:00.000+00:00')}
                    disableClock
                  />
                  <Box position='absolute'>
                    {state.endDateError && (
                      <div className='date-error'>
                        Finish date cannot be earlier than Start date
                      </div>
                    )}
                  </Box>
                  {!state.endDate && props.generalError.endDateError && (
                    <div className='validate-address-error'>Required</div>
                  )}
                </Box>
              </Box>
            </Box>
          </Card>
          <Box marginTop='2em'>
            <Card>
              <Box padding='2em'>
                <Typography variant='h6' gutterBottom className='base-color'>
                  Partial CountDown
                </Typography>
                <hr />
                <Box
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                >
                  <Typography gutterBottom className='base-color'>
                    Status
                  </Typography>
                  {/* <BooleanInput
                    label=''
                    source='stepperCountdown.isActive'
                    disabled={props.isShow}
                  /> */}
                  <Switch
                    checked={state.stepperIsActive}
                    color='primary'
                    onChange={handleChangeStepperCountdownActive}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Box>
                <Box
                  width={'100%'}
                  display='flex'
                  justifyContent='flex-start'
                  flexDirection={'column'}
                >
                  <Typography gutterBottom className='base-color'>
                    Stepper Title
                  </Typography>

                  <TextInput
                    className='input-form'
                    onChange={handleChangeStepperTitle}
                    disabled={props.isShow}
                    source='stepperCountdown.title'
                    label=' Stepper Title'
                    fullWidth
                  />
                </Box>
                <Box
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                >
                  <Typography gutterBottom className='base-color'>
                    Start date
                  </Typography>
                  <Box>
                    <DateTimePicker
                      // disabled={state.isActiveDreamHome}
                      value={state.stepperStartAt}
                      format={'dd-MM-y h:mm:ss a'}
                      onChange={setStepperStartDate}
                      maxDate={new Date('2051-01-18T19:55:00.000+00:00')}
                      minDate={new Date('2000-01-18T19:55:00.000+00:00')}
                      disableClock
                    />
                    <Box position='absolute'>
                      {state.stepperStartDateError && (
                        <div className='date-error'>
                          Start date cannot be later than finish date
                        </div>
                      )}
                    </Box>
                    {/* {!state.startDate && props.generalError.startDateError && (
                      <div className='validate-address-error'>Required</div>
                    )} */}
                  </Box>
                </Box>
                <Box
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                  marginTop='2em'
                >
                  <Typography gutterBottom className='base-color'>
                    Finish date
                  </Typography>
                  <Box>
                    <DateTimePicker
                      value={state.stepperEndsAt}
                      format={'dd-MM-y h:mm:ss a'}
                      onChange={setStepperEndDate}
                      maxDate={new Date('2051-01-18T19:55:00.000+00:00')}
                      minDate={new Date('2000-01-18T19:55:00.000+00:00')}
                      disableClock
                    />
                    <Box position='absolute'>
                      {state.stepperEndDateError && (
                        <div className='date-error'>
                          Finish date cannot be earlier than Start date
                        </div>
                      )}
                    </Box>
                    {/* {!state.endDate && props.generalError.endDateError && (
                      <div className='validate-address-error'>Required</div>
                    )} */}
                  </Box>
                </Box>
              </Box>
            </Card>
          </Box>
          <Box marginTop='2em'>
            <Card>
              <Box padding='2em'>
                <Typography variant='h6' gutterBottom className='base-color'>
                  Options
                </Typography>
                <hr />
                <Box
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                >
                  <Typography gutterBottom className='base-color'>
                    Trending
                  </Typography>
                  <BooleanInput source='isTrending' />
                </Box>

                <Box
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                >
                  <Typography gutterBottom className='base-color'>
                    Popular
                  </Typography>
                  <BooleanInput source='isPopular' />
                </Box>
              </Box>
            </Card>
          </Box>
          <Box marginTop='2em'>
            <Card>
              <Box padding='2em'>
                <Typography variant='h6' gutterBottom className='base-color'>
                  Meta Tags
                </Typography>
                <hr />
                <Box
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                >
                  <Typography gutterBottom className='base-color'>
                    Meta Title
                  </Typography>
                  <TextInput
                    className='input-form'
                    disabled={props.isShow}
                    source='metaTitle'
                    label='Add a metaTitle'
                  />
                </Box>

                <Box
                  display='flex'
                  alignItems='center'
                  justifyContent='flex-start'
                >
                  <Typography gutterBottom className='base-color'>
                    Meta Description
                  </Typography>
                  <TextInput
                    className='input-form'
                    disabled={props.isShow}
                    source='metaDescription'
                    label='Add a metaDescription'
                  />
                </Box>
              </Box>
            </Card>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DreamHomeGeneral;
